import usuarios from '../../api/usuarios'

export const handleAlterarEmail = async (formData, token) => {
  const body = {
    emailAtual: formData.email,
    emailNovo: formData.newEmail,
    senha: formData.password,
    idCliente: formData.id
  }

  let res = await usuarios.alterarEmailV2(body, token)

  res = await res.json()
  return res
}
